import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './styles.css';

class DocumentsLayouter extends Component {
	render() {
		const { children } = this.props;
		return <div className="documents-layouter">{children}</div>;
	}
}

DocumentsLayouter.propTypes = {
	children: PropTypes.node.isRequired
};

export default DocumentsLayouter;
